import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMe, useMarkHintSeen } from "@/api/hooks";
import { isActivationModalOpen, subscribeActivationModal } from "@/lib/activationGate";
import { InstructionFlow } from "@/components/instruction/InstructionKit";
import { BASIC_STEPS } from "@/components/instruction/content";

/**
 * Базова інструкція (5-7 кроків) — повноекранний блокуючий оверлей одразу
 * після оформлення підписки. Показується 1 раз (seen_hints містить 'basic').
 * Стартує лише ПІСЛЯ закриття попапа активації підписки (activationGate).
 * Далі — контекстні підказки розділів через <SectionHint/>.
 *
 * Адмінів теж пускаємо (без вимоги підписки) — щоб власник міг тестувати.
 */
export function InstructionOverlay() {
  const me = useMe();
  const mark = useMarkHintSeen();
  const navigate = useNavigate();
  const [activationOpen, setActivationOpen] = useState(isActivationModalOpen());
  useEffect(() => subscribeActivationModal(setActivationOpen), []);

  const d = me.data;
  const eligible =
    !!d &&
    d.onboarding_completed &&
    (d.has_active_subscription || d.is_admin) &&
    !d.seen_hints.includes("basic");

  if (!eligible || activationOpen) return null;

  return (
    <InstructionFlow
      steps={BASIC_STEPS}
      eyebrow="Інструкція · обовʼязково"
      finishLabel="Почати користуватись"
      firstLabel="Почати →"
      onDone={() => {
        mark.mutate("basic");
        // Уводимо на головну «/» (там немає секційних підказок), щоб одразу
        // після базового онбордингу не всплив другий «обовʼязковий» оверлей
        // на тій самій сторінці. Підказки розділів — лише при вході в розділ.
        navigate("/");
      }}
    />
  );
}
